import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UserStateService {
    private userNameSubject = new BehaviorSubject<string>('');
    private userEmailSubject = new BehaviorSubject<string>('');

    userName$ = this.userNameSubject.asObservable();
    userEmail$ = this.userEmailSubject.asObservable();

    updateUserData(name: string, email: string): void {
        this.userNameSubject.next(name);
        this.userEmailSubject.next(email);
    }

    getCurrentUserName(): string {
        return this.userNameSubject.value;
    }

    getCurrentUserEmail(): string {
        return this.userEmailSubject.value;
    }

    clearUserData(): void {
        this.userNameSubject.next('');
        this.userEmailSubject.next('');
    }
}
